var include_modal = `
<div class="modal-wrap">
		<div class="overlay"></div>
		<div class="modal">
			<div class="modal-inner">
				<button type="button" class="modal-btn-close">
					<img src="/material/img/common/icon/modal_close.png" alt="閉じる">
				</button>
				<div class="modal__head" id="modal-head">
				</div>
				<div class="modal__content" id="modal-content">
				</div>
			</div>
		</div>
	</div>
`;